import PrevArrowImage from "../../assets/img/icons/user/prevArrow.png";
import React from "react";

export function SamplePrevArrow(props) {
    const {className, style, onClick} = props;
    return (
        <div onClick={onClick}>
            <img src={PrevArrowImage} alt="Next" className={`${className}`}
                 style={{...style, display: "block", width: "auto", height: "auto"}}/>
        </div>
    );
}